import { timestamp } from "../../lib/format";
import { orderJourney } from "../../lib/orderFlow";
import type { PublicOrder } from "../../lib/types";

/**
 * Created → paid → started → closed, as four steps. Where the filled marks stop is
 * where the order stopped, which is most of the diagnosis before a word is read.
 * Times are the depot's, like everywhere else on an order.
 */
export function OrderJourney({ row }: { readonly row: PublicOrder }) {
  const steps = orderJourney(row);

  return (
    <ol aria-label="Journey" className="m-0 grid list-none grid-cols-4 gap-0 p-0">
      {steps.map((step, index) => (
        <li key={step.label} className="flex min-w-0 flex-col gap-1.5">
          <div className="flex items-center">
            <span
              aria-hidden="true"
              className={[
                "block size-2.5 shrink-0 rounded-full",
                step.status === "done"
                  ? "bg-ink"
                  : step.status === "waiting"
                    ? "border border-dashed border-ink-muted"
                    : "border border-rule",
              ].join(" ")}
            />
            {index === steps.length - 1 ? null : (
              <span
                aria-hidden="true"
                className={`h-0 flex-1 border-t ${steps[index + 1]?.status === "done" ? "border-ink" : "border-dashed border-rule"}`}
              />
            )}
          </div>
          <span
            className={`text-micro font-medium uppercase ${step.status === "done" ? "text-ink" : "text-ink-faint"}`}
          >
            {step.label}
          </span>
          <span className="pr-2 text-data tabular-nums text-ink-muted">
            {step.status === "done"
              ? timestamp(step.at, row.depotTimezone)
              : step.status === "waiting"
                ? "not yet"
                : "never"}
          </span>
        </li>
      ))}
    </ol>
  );
}
